export enum generationTypes {
    FETCH_GENERATIONS_REQUEST = 'FETCH_GENERATIONS_REQUEST',
    CREATE_GENERATION_REQUEST = 'CREATE_GENERATION_REQUEST',
    SET_GENERETIONS = 'SET_GENERETIONS',
}
